import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";

import {
  allCountKeys,
  allRequestListKeys,
  invalidateQueryKeys,
} from "@/hooks/queryKeys";

export function useNavigateToRequestList() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (options?: { showProcessing?: boolean }) => {
    invalidateQueryKeys(queryClient, [...allRequestListKeys, ...allCountKeys]);

    if (options?.showProcessing) {
      navigate({
        search: { filter: "all", scroll: "in-queue", tab: "queued" },
        to: "/requests",
      });
    } else {
      navigate({ search: { filter: "all" }, to: "/requests" });
    }
  };
}
